import { Header, Footer, PageHero, GalleryBlock, EstimateForm } from "@/components/site";

export default function GalleryPage() {
  return (
    <div className="bg-white text-slate-800">
      <Header />
      <PageHero overline="Our Work" title="Recent Projects & Results" subtitle="See the quality and craftsmanship we bring to every home and business across Aurora and the GTA." />
      <GalleryBlock />
      <EstimateForm />
      <Footer />
    </div>
  );
}
